export const PLATFORM_COMMISSION_LEVELS_MIN = 3;

export function buildCommissionLevels(items, maxAmount) {
  items = Array.isArray(items) ? items : [];

  const length = Math.max(PLATFORM_COMMISSION_LEVELS_MIN, items.length);

  return Array.from({ length }, (_, index) => {
    let from = items[index]?.from || '';
    let to = items[index]?.to || '';
    const fee = items[index]?.fee || '';

    if (index === 0) {
      from = 0;
    } else if (items[index - 1]?.to) {
      from = items[index - 1].to;
    }

    if (index === length - 1) {
      to = maxAmount;
    } else if (!to && items[index + 1]?.from) {
      to = items[index + 1].from;
    }

    return {
      from,
      to,
      fee,
    };
  });
}
